export enum LabType {
  MAINLAB = 'MAIN_LAB',
  BRANCH = 'BRANCH',
  LAB = 'LAB',
  HOSPITALLAB = 'HOSPITAL_LAB',
  CLINICLAB = 'CLINIC_LAB'
}
